// src/components/SideMenu.js
import { Link } from 'react-router-dom';
import logo from "../assets/1.png"; // or .png

const buttonStyle = {
  background: "none",
  border: "none",
  padding: 0,
  color: "#28384a",
  fontWeight: 600,
  fontSize: 18,
  textAlign: "left",
  cursor: "pointer",
  textDecoration: "none"
};


export default function SideMenu({ onGoHome, navigate, className }) {

  return (
    <div
  className={className ? className : "side-menu"}
  style={{
    position: "fixed",
    width: 220,
    minHeight: "100vh",
    background: "#f4f8ff",
    padding: "30px 14px",
    boxShadow: "2px 0 8px #e5e9f3"
  }}
>

      <div style={{ textAlign: "center", marginBottom: 16 }}>
  <img
    src={logo}
    alt="UAC Logo"
    style={{
      maxWidth: "120px",
      width: "90%",
      height: "auto",
      marginBottom: 8,
      borderRadius: 8,
      boxShadow: "0 2px 8px rgba(0,0,0,0.09)"
    }}
  />
</div>
<div
  style={{
    fontWeight: 700,
    fontSize: 18,
    color: "#176bb7",
    marginBottom: 32,
    textAlign: "center",
    letterSpacing: 1
  }}
>
  Universities Admission Service
</div>

      <nav style={{ display: "flex", flexDirection: "column", gap: 18 }}>
        
  <button
    onClick={onGoHome}
    style={buttonStyle}
  >
    Home
  </button>


  <button
    onClick={() => navigate('/universities')}
    style={buttonStyle}
  >
    Universities
  </button>


  <button
    onClick={() => navigate('/mission')}
    style={buttonStyle}
  >
    Mission
  </button>


  <button
    onClick={() => navigate('/terms')}
    style={buttonStyle}
  >
    Terms
  </button>


  <button
    onClick={() => navigate('/contact')}
    style={buttonStyle}
  >
    Contact
  </button>


      </nav>
    </div>
  );
}
